import { RestrictedAccountObjectDto } from "../restricted-account-object/restricted-account-object.dto";
import { DtoInclude, DtoRef, DtoRefList } from "../../../core/store/dto/dto";

export class TransitionDto extends RestrictedAccountObjectDto {
    @DtoInclude
    title: string;
    @DtoRefList
    fromStatuses: Array<string>;
    @DtoRef
    jobStatus: string;
    @DtoRefList
    notificationTemplates: Array<string>;
    @DtoRefList
    defaultTasks: Array<string>;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.dto.ts